import { createStore } from 'vuex'

export default createStore({
  state: {
    user:null
  },
  mutations: {
  },
  actions: {
    setUser({state},value){

      state.user=value

    }
  },
  modules: {
   
   
  }
})
